module.exports = __webpack_public_path__ + "static/img/Crop_00444_strona_004.882833c4.jpg";